import Simplebar from "simplebar";
import "simplebar/dist/simplebar.min.css";

export default {
  init: () => {
    document.querySelectorAll("[data-simplebar]").forEach((el) => {
      new Simplebar(el, { autoHide: false });
    });
  },
};
